angular.module('zc.zenclerkS')
  .controller('AcceptInvitationController', AcceptInvitationController);

AcceptInvitationController.$inject = [
  '$stateParams',
  '$translate',
  '$window',
  'Devise',
  'Page',
  'afterLoginHandler',
  'invitedUser',
];
function AcceptInvitationController(
  $stateParams,
  $translate,
  $window,
  Devise,
  Page,
  afterLoginHandler,
  invitedUser,
) {
  $translate('users.invitation.invitation').then(translation => Page.setTitle(translation));

  const vm = this;
  vm.user = invitedUser;
  vm.isAgreeToTosAndPrivacyPolicy = false;

  vm.setLanguage = lang => {
    $translate.use(lang);
    vm.selectedLanguage = lang;
    vm.user.lang = lang;
    $window.document.documentElement.lang = lang;
  };

  vm.setLanguage(invitedUser.lang);

  vm.submit = () => {
    if(!vm.isAgreeToTosAndPrivacyPolicy) return;

    Devise
      .accept(angular.extend({invitation_token: $stateParams.invitation_token}, vm.user))
      .then(user => Devise.signAgreements(user))
      .then(user => afterLoginHandler.handle(user));
  };
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/users/invitation/accept_invitation.controller.js